// extracted by mini-css-extract-plugin
module.exports = {"property-wrapper":"yk9kW","propertyWrapper":"yk9kW"};